const en = {
  nav: {
    login: 'Login',
    bookNow: 'Book Now',
    dashboard: 'Dashboard',
    back: 'Back',
    home: 'Home',
  },
  landing: {
    heroTitle1: 'Sky-High Journeys,',
    heroTitle2: 'Simplified',
    heroSubtitle: "India's Premier Helicopter Charter Aggregator. Connect with verified operators, book flights instantly, and soar above the ordinary.",
    bookYourFlight: 'Book Your Flight',
    becomeOperator: 'Become an Operator',
    whyChoose: 'Why Choose AirYatra?',
    verifiedOperators: 'Verified Operators',
    verifiedOperatorsDesc: 'All operators are thoroughly verified with AOC certificates, insurance, and safety compliance.',
    bestPrices: 'Best Prices',
    bestPricesDesc: 'AI-powered price suggestions ensure you get competitive quotes from multiple operators.',
    seamlessBooking: 'Seamless Booking',
    seamlessBookingDesc: 'From quote requests to digital tickets, manage your entire journey in one platform.',
    flightsCompleted: 'Flights Completed',
    verifiedOperatorsStat: 'Verified Operators',
    safetyRecord: 'Safety Record',
    customerRating: 'Customer Rating',
    premiumServices: 'Premium Services',
    elevateExperience: 'Elevate Your Experience',
    premiumSubtitle: 'Unlock exclusive benefits with our premium membership and corporate travel solutions',
    blackDesc: 'Premium membership with up to 20% discount, priority booking, dedicated pilot, and exclusive lounge access.',
    priorityQueue: 'Priority Booking Queue',
    dedicatedManager: 'Dedicated Relationship Manager',
    freeCancellation: 'Free Cancellation',
    exploreMembership: 'Explore Membership',
    aviationExchange: 'Aviation Exchange',
    exchangeDesc: 'Buy, sell, or lease aircraft with our secure marketplace. Real-time valuations and verified listings.',
    liveTracking: 'Live Market Tracking',
    instantQuotes: 'Instant Valuations',
    securePayments: 'Secure Transactions',
    exploreExchange: 'Explore Exchange',
    corporateSolutions: 'Corporate Solutions',
    corporateConsole: 'Corporate Console',
    corporateDesc: 'Centralized travel management for enterprises with approval workflows, budgets, and consolidated billing.',
    employeeManagement: 'Employee Management',
    budgetControls: 'Budget Controls',
    travelAnalytics: 'Travel Analytics',
    volumeDiscounts: 'Volume Discounts',
    corporateRegistration: 'Corporate Registration',
    documentVault: 'Document Vault',
    vaultDesc: 'Secure encrypted storage for DGCA documents, insurance, licenses with expiry alerts and version control.',
    encryption: 'AES-256 Encryption',
    expiryReminders: 'Expiry Reminders',
    secureSharing: 'Secure Sharing',
    openVault: 'Open Vault',
    loginToAccess: 'Login to Access',
    readyTakeOff: 'Ready to Take Off?',
    ctaSubtitle: 'Book your helicopter charter today and experience aviation excellence.',
    startBooking: 'Start Booking',
    footerText: "© 2025 AirYatra. All rights reserved. India's Premier Helicopter Charter Platform.",
  },
  booking: {
    title: 'Book Your Flight',
    subtitle: 'AirYatra - Premium Air Mobility Services',
    previous: 'Previous',
    next: 'Next',
    loginPrompt: 'Please login to submit booking inquiry',
    loginBtn: 'Login',
    steps: {
      passengers: 'Passengers',
      booking_type: 'Booking Type',
      route: 'Route',
      price_inquiry: 'Price',
    },
  },
  bookingForm: {
    selectAircraftType: 'Select Aircraft Type',
    maxPassengers: 'Max {{count}} passengers',
    adultPassengers: 'Adult Passengers',
    male: 'Male',
    female: 'Female',
    totalAdults: 'Total Adults',
    children: 'Children (Up to 4 years)',
    childrenFree: 'FREE - Max 2 children',
    flightType: 'Flight Type',
    selectOption: '-- Select --',
    bookingFor: 'Booking For',
    bookingPurpose: 'Booking Purpose',
    selected: 'Selected',
    specifyPurpose: 'Specify purpose',
    pickupLocation: 'Pickup Location',
    selectPickupPoint: 'Select Pickup Point',
    dropLocation: 'Drop Location',
    selectDropPoint: 'Select Drop Point',
    estimatedDistance: 'Estimated Distance',
    villageDocsTitle: 'Village Landing - Documents Required',
    villageDocsDesc: 'For landing on village/private land, you must obtain the following documents from the Authority:',
    villageDocsNote: 'After booking confirmation, you must upload these documents. Admin/Operator will verify them before the pilot takes off.',
    departureDate: 'Departure Date',
    pickupTime: 'Pickup Time',
    additionalOptions: 'Additional Options (Optional)',
    waitingTime: 'Waiting Time (minutes)',
    waitingTimeNote: 'First 30 min free, then charges apply',
    nightHalts: 'Night Halts',
    nightHaltsNote: 'Includes crew accommodation charges',
    bookingSummary: 'Booking Summary',
    aircraftTypeLabel: 'Aircraft Type:',
    totalPassengersLabel: 'Total Passengers:',
    adults: 'Adults',
    childrenLabel: 'Children',
    flightTypeLabel: 'Flight Type:',
    pickupLabel: 'Pickup:',
    dropLabel: 'Drop:',
    distanceLabel: 'Distance:',
    dateTimeLabel: 'Date & Time:',
    at: 'at',
    villageApprovalTitle: 'Village Landing - Admin Approval Required',
    villageApprovalDesc: 'Your inquiry will be submitted for admin approval. Payment will be enabled after approval.',
    priceBreakdown: 'Price Breakdown',
    baseFlightCost: 'Base Flight Cost',
    flightCost: 'Flight Cost',
    positioningCost: 'Positioning Cost (Dead-leg)',
    roundTripDiscount: 'Round Trip Discount',
    operatorGrossCost: 'Operator Gross Cost',
    additionalCharges: 'Additional Charges',
    waitingGroundHolding: 'Waiting / Ground Holding',
    nightHalt: 'Night Halt ({{count}} nights)',
    crewAccommodation: 'Crew Accommodation & Food',
    fuelSurcharge: 'Fuel Surcharge',
    platformFees: 'Platform Fees',
    convenienceFee: 'Convenience Fee',
    insurance: 'Insurance',
    peakSurge: 'Peak Season Surge',
    platformCommission: 'Platform Commission',
    included: 'Included',
    helipadCharges: 'Helipad Landing Charges',
    totalLandingCharges: 'Total Landing Charges',
    taxableAmount: 'Taxable Amount',
    totalGst: 'Total GST',
    grandTotal: 'Grand Total',
    inclusiveTaxes: 'Inclusive of all taxes',
    operatorReceives: 'Operator will receive',
    specialRequirements: 'Special Requirements (Optional)',
    specialRequirementsPlaceholder: 'Any special requests or requirements...',
    submitting: 'Submitting...',
    submitApproval: 'Submit for Approval',
    generateInquiry: 'Submit Inquiry',
    approvalNote: 'Your inquiry requires admin approval for village landing.',
    inquiryNote: 'After inquiry, operators will review and send you their quotes.',
    formRestored: 'Form data restored!',
    selectAircraftError: 'Please select aircraft type',
    minAdultError: 'At least 1 adult passenger required',
    maxChildrenError: 'Maximum 2 children allowed',
    selectFlightTypeError: 'Please select flight type',
    selectBookingForError: 'Please select who the booking is for',
    selectPurposeError: 'Please select booking purpose',
    selectPickupError: 'Please select pickup location',
    selectDropError: 'Please select drop location',
    selectDateError: 'Please select departure date',
    selectTimeError: 'Please select pickup time',
    priceWaitError: 'Price not calculated! Please wait for price calculation',
    inquirySubmitted: 'Inquiry submitted! Operators will respond soon',
    noteVillageApproval: 'Village landing requires admin approval',
    notePriceEngine: 'Price calculated by Aviation-Grade Pricing Engine',
    noteFinalPrice: 'Final price will be confirmed by operator',
    docCollectorNoc: 'Collector NOC',
    docFireDept: 'Fire Department Acknowledgment',
    docPoliceStation: 'Local Police Station Acknowledgment',
    docSpDcp: 'SP/DCP Acknowledgment',
  },
  options: {
    helicopter: 'Helicopter',
    chartered_plane: 'Chartered Plane',
    one_hour: '1 Hour Flight',
    two_hour: '2 Hour Flight',
    half_day: 'Half Day',
    full_day: 'Full Day',
    multi_city: 'Multi-City',
    point_to_point: 'Point-to-Point',
    self: 'Self',
    friend_family: 'Friend & Family',
    company: 'Company / Corporate',
    political: 'Political / VIP',
    other: 'Other',
    wedding: 'Wedding',
    temple_yatra: 'Temple Yatra',
    company_tour: 'Corporate Tour',
    election_tour: 'Election Campaign',
    medical_emergency: 'Medical Emergency',
    film_shooting: 'Film Shooting',
    general_tour: 'General Tour',
    pilgrimage: 'Pilgrimage',
    business: 'Business Meeting',
  },
};

export default en;
